module.exports = __webpack_public_path__ + "img/breatlas.d819cef5.jpg";